<template>
  <layout-popup width="428">
    <template slot="header">
      Download history
    </template>
    <template>
      <div class="mx-4">
        <history-datepicker-range-field
          :mode-selection="modeSelection"
          v-model="datesRange"
          label="From — To"
          is-start
        />
        <div class="d-flex align-center mx-0" v-if="withShape">
          <div style="font-size: 16px">Download wide data</div>
          <v-spacer />
          <v-switch
            data-test-switch="wideData"
            class="ma-0 py-3"
            hide-details
            true-value="wide"
            false-value="long"
            v-model="shape"
          ></v-switch>
        </div>
        <v-expand-transition>
          <v-alert dense color="red" type="error" v-if="state.value.error">
            Error during download history, please, try later
          </v-alert>
        </v-expand-transition>
      </div>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text @click="close">
        close
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="apply"
        :loading="state.value.loading"
        :disabled="state.value.loading || datesRange.length < 2"
      >
        download
      </v-btn>
    </template>
  </layout-popup>
</template>

<script>
import HistoryDatepickerField from '@/components/history-card/HistoryDatepickerField';
import LayoutPopup from '@/layouts/LayoutPopup';
import HistoryDatepickerRangeField from "@/components/history-card/HistoryDatepickerRangeField.vue";

export default {
  name: 'HistoryDatePopup',
  props: {
    modeSelection: {
      type: String,
      default: 'day'
    },
    isShow: {
      type: Boolean,
      default: false
    },
    withShape: {
      type: Boolean,
      default: false
    },
    state: {
      type: Object,
      default: () => ({ value: null })
    }
  },
  components: {
    HistoryDatepickerRangeField,
    LayoutPopup,
    HistoryDatepickerField
  },
  data() {
    return {
      datesRange: [],
      shape: 'wide'
    };
  },
  methods: {
    apply() {
      this.$emit('input', this.datesRange, this.shape);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
